import { type OpenApiSchemaBindingMode } from '#shared/api/schema';

export const ADDITIONAL_PRODUCTS_SOURCE_MODE = {
    AI: 'AI_RECOMMENDATION',
    MANUAL: 'MANUAL',
} as const;

export const ADDITIONAL_PRODUCTS_SAVE_PAYLOAD_TYPE = {
    AI: 'AI',
    MANUAL: 'MANUAL',
} as const;

export type AdditionalProductsSourceMode =
    (typeof ADDITIONAL_PRODUCTS_SOURCE_MODE)[keyof typeof ADDITIONAL_PRODUCTS_SOURCE_MODE];

export const ADDITIONAL_PRODUCTS_MANUAL_MODE = {
    ALL: 'ALL_VARIANTS',
    SELECTED: 'SELECTED_CARDS',
    CATEGORIES: 'SELECTED_CATEGORIES_COLLECTIONS',
} as const satisfies Record<string, OpenApiSchemaBindingMode>;

export type AdditionalProductsManualMode =
    (typeof ADDITIONAL_PRODUCTS_MANUAL_MODE)[keyof typeof ADDITIONAL_PRODUCTS_MANUAL_MODE];

export type AdditionalProductsBindingFormValue = {
    productListId: string;
    categoryIds: string[];
    collectionIds: string[];
};

export type AdditionalProductsFormValue = {
    sourceMode: AdditionalProductsSourceMode;
    manualMode: AdditionalProductsManualMode;
    binding: AdditionalProductsBindingFormValue;
};

export const ADDITIONAL_PRODUCTS_GALLERY_MAX_CARDS = 25;
